export { updatePortalAnnouncementsEpic } from './epic';
